import env from 'env';
import { experiment } from '@podiumhq/tracking';

export default function setupTracking() {
  const isDevelopment = process.env.NODE_ENV === 'development';

  if (env.AMPLITUDE_EXPERIMENT_TOKEN) {
    experiment.init({
      connectToAnalytics: true,
      debug: isDevelopment,
      enabled: true,
      environmentKey: env.AMPLITUDE_EXPERIMENT_TOKEN,
    });
  }
}
